/**
 * App.jsx
 * 
 * Componente principal de la aplicación
 * 
 * Qué hace:
 * - Configura el router de la aplicación
 * - Proporciona el contexto de simulación a todos los componentes
 * - Maneja las rutas de la aplicación
 * 
 * Qué recibe:
 * - No recibe props
 * 
 * Qué devuelve:
 * - JSX con la estructura principal de la app y rutas
 * 
 * Dónde modificarlo:
 * - Para agregar nuevas rutas
 * - Para agregar componentes globales (header, footer, etc.)
 */

import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { SimulacionProvider } from './context/SimulacionContext'
import RuteoPruebas from './pages/RuteoPruebas'
import SeguimientoCliente from './pages/SeguimientoCliente'
import Monitoreo from './pages/Monitoreo'
import Repartidor from './pages/Repartidor'

function App() {
  return (
    <SimulacionProvider>
      <BrowserRouter>
        <div className="app">
          <Routes>
            <Route path="/" element={<RuteoPruebas />} />
            <Route path="/seguimiento/:id" element={<SeguimientoCliente />} />
            <Route path="/monitoreo" element={<Monitoreo />} />
            <Route path="/repartidor/:linkId" element={<Repartidor />} />
          </Routes>
        </div>
      </BrowserRouter>
    </SimulacionProvider>
  )
}

export default App

